import { render, staticRenderFns } from "./ContactEditAddress.vue?vue&type=template&id=73bd78c6"
import script from "./ContactEditAddress.vue?vue&type=script&lang=ts"
export * from "./ContactEditAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73bd78c6')) {
      api.createRecord('73bd78c6', component.options)
    } else {
      api.reload('73bd78c6', component.options)
    }
    module.hot.accept("./ContactEditAddress.vue?vue&type=template&id=73bd78c6", function () {
      api.rerender('73bd78c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contacts/ContactEditAddress.vue"
export default component.exports